<template>
  <div class="">
    <vue-custom-scrollbar
      :style="
        `overflow: hidden; position: relative; height: calc(100vh - 120px)`
      "
      :settings="{ maxScrollbarLength: 60 }"
      class="pd-10"
    >    
      <Form label-position="top" class="pd-r-5 pd-l-5 report-filter-form">
        <FormItem label="Огноо эхлэх">
          <DatePicker
            type="date"
            v-model="srch.startDate"
            :format="'yyyy.MM.dd'"
            :value-format="'yyyy.MM.dd'"
            placeholder="сонгоно уу"
            class="wd-100p-f"
          ></DatePicker>
        </FormItem>
        <FormItem label="Огноо дуусах">
          <DatePicker
            type="date"
            v-model="srch.endDate"
            :format="'yyyy.MM.dd'"
            :value-format="'yyyy.MM.dd'"
            placeholder="сонгоно уу"
            class="wd-100p-f"
          ></DatePicker>
        </FormItem>
        <FormItem label="Сургалт" v-if="$store.state.user.userInfo.groupId != 9237">
          <Select
            v-model="srch.courseId"
            filterable
            clearable
            @change="loadBox"
            class="wd-100p"
          >
            <Option
              v-for="(t, i) in filterData.tasks"
              :value="t.id"
              :key="i"
              :label="`${i + 1}.) ${t.task}`"
              >{{ i + 1 }}.) {{ t.task }} ({{
                t.dueStartDate | moment("YYYY.MM.DD")
              }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
            >
          </Select>
        </FormItem>
        <FormItem label="Хичээл" v-if="$store.state.user.userInfo.groupId != 9237">
          <Select v-model="srch.lessonId" filterable clearable class="wd-100p">
            <Option
              v-for="(t, i) in filterData.boxes"
              :value="t.id"
              :key="i"
              :label="`${i + 1}.) ${t.task}`"
              >{{ i + 1 }}.) {{ t.task }} ({{
                t.dueStartDate | moment("YYYY.MM.DD")
              }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
            >
          </Select>
        </FormItem>
        <FormItem label="Газар / Нэгж" v-if="!hasPermission(['reporttagviewer'])" v-show="$store.state.user.userInfo.groupId != 9237">
          <depart-finder @on-depart-selected="departSelected"></depart-finder>
        </FormItem>
        <FormItem label="Ажилтан / Хэрэглэгч">
          <user-finder
            v-if="
              $store.state.app.mainReportData.propObj.loginName != undefined &&
                $store.state.app.mainReportData.propObj.loginName != null
            "
            @on-user-finded="userFinded"
            :defaultValue="
              $store.state.app.mainReportData.show
                ? {
                    mode: '1',
                    value: $store.state.app.mainReportData.propObj.loginName
                  }
                : null
            "
            class="pd-x-10"
          ></user-finder>
          <user-finder
            v-else
            @on-user-finded="userFinded"
            class="pd-x-10"
          ></user-finder>
        </FormItem>
      </Form>
    </vue-custom-scrollbar>
    <div class="pd-10 bg-white bd-t">
      <button
        @click="$emit('on-seach', srch)"
        class="btn btn-xs btn-primary btn-block btn-uppercase"
      >
        Ачааллах
      </button>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Form, FormItem, DatePicker, Button, Select, Option } from "element-ui";

var _ = require("lodash");
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    Form,
    FormItem,
    DatePicker,
    Button,
    Select,
    Option,
    vueCustomScrollbar,
    departFinder: () => ({
      component: import("@/components/modules/hr/departFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userFinder: () => ({
      component: import("@/components/modules/hr/userFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      srch: {
        startDate: null,
        endDate: null,
        userId: "",
        departs: [],
        courseId: null,
        lessonId: null
      },
      filterData: {
        tasks: [],
        boxes: []
      }
    };
  },
  mounted() {
    if (this.$store.state.app.mainReportData.show) {
      if (
        this.$store.state.app.mainReportData.propObj.loginName != undefined &&
        this.$store.state.app.mainReportData.propObj.loginName != null
      )
        this.srch.userId = this.$store.state.app.mainReportData.propObj.loginName;

      if (
        this.$store.state.app.mainReportData.propObj.courseId != undefined &&
        this.$store.state.app.mainReportData.propObj.courseId != null
      ) {
        this.srch.courseId = this.$store.state.app.mainReportData.propObj.courseId;
        this.$emit("on-seach", this.srch);
      }
    }

    this.srch.startDate = moment()
      .startOf("year")
      .format("yyyy.MM.DD");
    this.srch.endDate = moment().format("yyyy.MM.DD");

    this.fillCourse();
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    departSelected(e) {
      this.srch.departs = e.departs;
      //this.$emit('on-seach', this.srch);
    },
    userFinded(e) {
      //console.log('userFinded', e);
      this.srch.userId = e.userId;
      this.$emit("on-seach", this.srch);
    },
    fillCourse() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == 115
      );
      if (proj.length) {
        _pid = proj[0].id;
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 2000,
            id: 0,
            model: this.coreSearchModel
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res.data.tasks.length > 0)
            this.filterData.tasks = _.orderBy(res.data.tasks, ["id"], ["desc"]);
          else
            this.filterData.tasks = [
              { id: 0, task: "Байгууллагын админд хандана уу" }
            ];
        });
      }
    },
    loadBox(e) {
      if (e > 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "task/taskInheritedDetail" },
          params: {
            id: e
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            //console.log('taskInheritedDetail', res);
            let tb = res.data.task.b;
            if (tb.length > 0) {
              if (tb.filter(b => b.ot == 114).length > 0) {
                this.toggleBodyClass("addClass", "dynamic-locker");
                let bid = tb.filter(b => b.ot == 114)[0].id;
                request({
                  api: { method: "post", url: "taskCore/coreBoxInTaskList" },
                  data: {
                    id: bid,
                    skip: 0,
                    size: 500
                  },
                  store: this.$store
                }).then(resb => {
                  //console.log('coreBoxInTaskList', resb);
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (resb != false) {
                    this.filterData.boxes = resb.data.tasks;
                  }
                });
              }
            }
          }
        });
      } else {
        this.filterData.boxes = [];
      }
    }
  }
};
</script>

<style lang="scss">
.report-filter-form {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__label {
      margin: 0;
      padding: 0;
      line-height: 16px;
    }
  }
}
</style>
